const ConditionalWrapper = ({condition, wrapper, children}) => (
  condition ? wrapper(children) : children ? children : null
);

export default ConditionalWrapper;
